import React, { ChangeEvent } from 'react';

import { Box, Button, Typography } from '@material-ui/core';
import { AiOutlinePlus } from 'react-icons/ai';

import { AppSearchInput } from '@vyce/core/src/components/inputs';
import { AppSwitch, FilterSystem } from '@vyce/core/src/components';
import { FilterSection } from '@vyce/core/src/types';
import { FormFolderDoc } from '@vyce/core/src/api/types';

interface Props {
  isFolderView: boolean;
  isArchivedView: boolean;
  isArchivedFoldersView?: boolean;
  folders: FormFolderDoc[];
  onSearchChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onFolderSearchChange: (value: string) => void;
  onFolderFilterChange: (folderId: string) => void;
  onArchivedViewChange: (checked: boolean) => void;
  onArchivedFoldersViewChange?: (checked: boolean) => void;
  onFolderViewChange: (checked: boolean) => void;
  onCreateFolder: () => void;
  onCreateForm: () => void;
  createItemLabel?: string;
  createItemFolderLabel?: string;
  itemSearchPlaceholder?: string;
  showFolderFilter?: boolean;
}

export const MyFormsToolbar: React.FC<Props> = ({
  isFolderView,
  isArchivedView,
  isArchivedFoldersView = false,
  folders,
  onSearchChange,
  onFolderSearchChange,
  onFolderFilterChange,
  onArchivedViewChange,
  onArchivedFoldersViewChange,
  onFolderViewChange,
  onCreateFolder,
  onCreateForm,
  createItemLabel = 'Create new form',
  createItemFolderLabel = 'Create new folder',
  itemSearchPlaceholder = 'Search...',
  showFolderFilter = true,
}) => {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" gridGap={16} marginBottom={2}>
      <Box display="flex" alignItems="center" gridGap={16}>
        <AppSearchInput
          placeholder={isFolderView ? 'Search folders...' : itemSearchPlaceholder}
          onChange={isFolderView ? e => onFolderSearchChange(e?.target?.value || '') : onSearchChange}
          isSmall
          smallRounding
          isBorder
          expanded={true}
        />

        {!isFolderView && showFolderFilter && (
          <FilterSystem
            filtersSections={
              [
                {
                  title: 'Folders',
                  expanded: true,
                  filters: [
                    {
                      type: 'select',
                      multiple: false,
                      label: 'Folder',
                      field: 'folderId',
                      values: [
                        { name: 'All folders', value: '' },
                        ...folders.map(folder => ({ name: folder.name, value: folder.id })),
                        { name: 'Unassigned', value: 'unassigned' },
                      ],
                      defaultValue: '',
                    },
                  ],
                },
              ] as FilterSection[]
            }
            onFiltersChange={values => onFolderFilterChange(values?.folderId || '')}
            buttonBorder
          />
        )}
      </Box>

      <Box display="flex" alignItems="center" gridGap={16}>
        {!isFolderView && (
          <AppSwitch
            checked={isArchivedView}
            onChange={onArchivedViewChange}
            leftOption={{
              content: <Typography style={{ fontSize: 14, fontWeight: 600 }}>Active</Typography>,
            }}
            rightOption={{
              content: <Typography style={{ fontSize: 14, fontWeight: 600 }}>Archived</Typography>,
            }}
          />
        )}

        {isFolderView && onArchivedFoldersViewChange && (
          <AppSwitch
            checked={isArchivedFoldersView}
            onChange={onArchivedFoldersViewChange}
            leftOption={{
              content: <Typography style={{ fontSize: 14, fontWeight: 600 }}>Active</Typography>,
            }}
            rightOption={{
              content: <Typography style={{ fontSize: 14, fontWeight: 600 }}>Archived</Typography>,
            }}
          />
        )}

        <AppSwitch
          checked={isFolderView}
          onChange={onFolderViewChange}
          leftOption={{
            content: <Typography style={{ fontSize: 14, fontWeight: 600 }}>List View</Typography>,
          }}
          rightOption={{
            content: <Typography style={{ fontSize: 14, fontWeight: 600 }}>Folder View</Typography>,
          }}
        />

        {isFolderView ? (
          <>
            <Button
              size="small"
              variant="contained"
              color="primary"
              style={{ width: '180px' }}
              startIcon={<AiOutlinePlus />}
              onClick={onCreateForm}
            >
              {createItemLabel}
            </Button>
            <Button
              size="small"
              variant="contained"
              color="primary"
              style={{ width: '180px' }}
              startIcon={<AiOutlinePlus />}
              onClick={onCreateFolder}
            >
              {createItemFolderLabel}
            </Button>
          </>
        ) : (
          <Button
            size="small"
            variant="contained"
            color="primary"
            style={{ width: '180px' }}
            startIcon={<AiOutlinePlus />}
            onClick={onCreateForm}
          >
            {createItemLabel}
          </Button>
        )}
      </Box>
    </Box>
  );
};
